import React, { Component } from 'react';
import { Head } from 'react-static';
import { withStyles } from '@material-ui/core/styles';
import { ThemeProvider } from 'styled-components';
import forOwn from 'lodash/forOwn';
import PublicHeader from '../PublicHeader';
import BrandGrid from './components/BrandGrid';
import TopSection from './components/TopSection';
import Typography from '../components/Typography';
import MemberTestimonials from './components/MemberTestimonials';
import PricingPlan from './components/PricingPlan';
import Comparison from './components/Comparison';
import Disclosures from './components/Disclosure';
import UserUtilityBar from '../HomePage/components/UserUtilityBar';
import { Col } from 'react-flexa';
import ImageSlider from '../components/ImageSlider/ImageSlider';

const styles = theme => ({
  root: {
    overflow: 'hidden',
    fontSize: '1rem',
    lineHeight: '1.5rem'
  },
  paragraph: {
    lineHeight: 1.5,
    maxWidth: '92%',
    margin: '0 auto'
  },
  diningTable: {
    width: '100%',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      height: '100%'
    }
  },
  conteinerImageslider: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    maxWidth: '80%',
    margin: '40px auto 20px auto',
    [theme.breakpoints.down(426)]: {
      margin: 0,
      maxWidth: '100%'
    }
  }
});

const BottomSliderImages = [
  '/pricingpage/slider-images/bottom-slider/Slide_1-Dining Table@2x.jpg',
  '/pricingpage/slider-images/bottom-slider/Slide_1-Platform Bed@2x.jpg',
  '/pricingpage/slider-images/bottom-slider/Slide_1-Sectional@2x.jpg'
];

class PricingPageContainer extends Component {
  constructor(props) {
    super(props);
    this.pricingRef = React.createRef();
    this.comparisonRef = React.createRef();
  }

  handleScrollToPricing = event => {
    window.scrollTo({
      top: this.pricingRef.current.offsetTop,
      behavior: 'smooth'
    });
  };

  handleScrollToComparison = event => {
    window.scrollTo({
      top: this.comparisonRef.current.offsetTop,
      behavior: 'smooth'
    });
  };

  render() {
    // eslint-disable-next-line react/prop-types
    const { classes, theme } = this.props;
    const breakpoints = {};
    forOwn(theme.breakpoints.value, (value, key) => {
      breakpoints[key] = value / 16;
    });
    return (
      <ThemeProvider theme={{ flexa: { breakpoints } }}>
        <div className={classes.root}>
          <Head>
            <title>DirectBuy Membership Pricing</title>
          </Head>
          <PublicHeader handleClick={this.handleScrollToPricing} />
          <div id="om-ygos74seei4wyw832dov-holder" />
          <TopSection
            handleScrollToPricing={this.handleScrollToPricing}
            handleScrollToComparison={this.handleScrollToComparison}
          />
          <Comparison locRef={this.comparisonRef} />
          <Col xs={12} sm={12} md={3} className={classes.conteinerImageslider}>
            <ImageSlider images={BottomSliderImages} />
          </Col>
          <div style={{ textAlign: 'center', paddingTop: '8%' }}>
            <Typography bold={true} variant="subtitle1" color="primary">
              ALL THESE SAVINGS
            </Typography>
            <Typography bold={true} variant="h2">
              Savings On Hundreds Of Brand Name Suppliers
            </Typography>
            <Typography className={classes.paragraph} variant="body2">
              For Home Improvement, Home D&#233;cor & Furnishings To Window
              Treatments, Mattresses & Much More!
              <br />
              For Everything In And Around Your Home!
            </Typography>
          </div>
          <BrandGrid />
          <MemberTestimonials />
          <PricingPlan locRef={this.pricingRef} />
          <Disclosures />
          <UserUtilityBar />
        </div>
      </ThemeProvider>
    );
  }
}

export default withStyles(styles, { withTheme: true })(PricingPageContainer);
